import React, { Component } from 'react'

export default class Home extends Component {
    render() {
        return (
            <div className="jumbotron jumbotron-fluid">
            <div className="container">
              <h1 className="display-4 text-light bg-success text-center">WELCOME TO OUR BLOG SITE</h1>
              <p className="lead bg-dark text-light text-center">Super Simple Web Blog For You</p>
            </div>
          </div>
        )
    }
}
